import _ from '@@/lodash';
import './ADA.less';

const ADA_DOM_TARGET = '[data-app="true"]';

/**
 * General sufficient timeout to be sure all DOM updates
 * have been completed before we can make further actions
 */
const ADA_DOM_UPDATE_TIMEOUT = 250;

/**
 * Most minimum timeout for DOM updates to complete for intercepting immediate
 * changes like input values, otherwise to late updates will cause screen
 * readers to read content before it's get updated
 */
const ADA_DOM_UPDATE_TIMEOUT_MIN = 100;

_.mixin({
	'isDate': function (date) {
		return date instanceof Date && !isNaN(date);
	},
});

if (typeof window.Element.prototype.matches !== 'function') {
	window.Element.prototype.matches =
	window.Element.prototype.msMatchesSelector ||
	window.Element.prototype.mozMatchesSelector ||
	window.Element.prototype.webkitMatchesSelector ||
	function (selector) {
		let i = 0;
		const nodes = document.querySelectorAll(selector);
		while (nodes[i] && nodes[i] !== this) {
			i++;
		}
		return Boolean(nodes[i]);
	};
}

if (typeof window.Element.prototype.closest !== 'function') {
	window.Element.prototype.closest = function (selector) {
		let node = this;
		while (node && node.nodeType === 1) {
			if (node.matches(selector)) {
				return node;
			}
			node = node.parentNode;
		}
		return null;
	};
}

function addEventListenerOnce(element, type, callback, options) {
	if (!window.singleEventListeners) {
		window.singleEventListeners = {};
	}
	if (!window.singleEventListeners[type]) {
		window.singleEventListeners[type] = {};
	}
	if (!(callback in window.singleEventListeners[type])) {
		window.singleEventListeners[type][callback] = true;
		element.addEventListener(type, function handler() {
			if (typeof options === 'object' && 'condition' in options && (!options.condition ||
				typeof options.condition === 'function' && !options.condition.apply(this, arguments))) {
				return;
			}
			element.removeEventListener(type, handler, options);
			delete window.singleEventListeners[type][callback];
			callback.apply(this, arguments);
		}, options);
	}
}

function queryFocusable(element) {
	const focusable = `
		[tabindex]:not([tabindex="-1"]),
		input:not([tabindex="-1"]),
		select:not([tabindex="-1"]),
		textarea:not([tabindex="-1"]),
		button:not([tabindex="-1"]),
		[role="button"][tabindex]:not([tabindex="-1"]),
		a[href]:not([tabindex="-1"])
	`;
	return element.matches(focusable) ? element : element.querySelector(focusable);
}

function isVisible(element) {
	return Boolean(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

function getOrdinalDate(date) {
	const n = date.getDate();
	return n + ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10];
}

function getFullMonth(date) {
	return ['January', 'February', 'March', 'April', 'May', 'June', 'July',
	'August', 'September', 'October', 'November', 'December'][date.getMonth()];
}

function keyCode(e) {
	return e.which || e.keyCode || e.charCode;
}

function ADAkeydown(e) {
	if (keyCode(e) === 13 && e.target.matches('[role="tab"]')) {
		if (_.isElement(e.target.closest('[aria-expanded="true"]'))) {
			e.stopPropagation();
		} else if (!e.target.matches('a, button')) {
			e.preventDefault();
			e.target.click();
		}
	}

	else if (_.includes([37, 39], keyCode(e)) && e.target.matches('[role="tab"]')) {
		let next, tabs = e.target.closest('[role="tablist"]');
		if (_.isElement(tabs) && _.size(tabs = tabs.querySelectorAll('[role="tab"]')) > 1) {
			const index = _.indexOf(tabs, e.target);
			if (keyCode(e) === 39) {
				next = _.get(tabs, index +1, _.head(tabs));
			} else {
				next = _.get(tabs, index -1, _.last(tabs));
			}
			e.target.setAttribute('tabindex', -1);
			next.setAttribute('tabindex', 0);
			next.focus();
		}
	}

	else if (_.includes([38, 40], keyCode(e)) && e.target.matches('[role="combobox"]')) {
		window.setTimeout(() => {
			let active = _.filter($content.querySelectorAll('[role="list"]'), node => isVisible(node));
			if (_.isElement(active = _.head(active))) {
				active = active.querySelector(e.target.dataset.activeSelector || '[aria-selected="true"]');
			}
			if (_.isElement(active)) {
				let value = active.innerText;
				if ('value' in active.dataset) {
					value = active.dataset.value;
				} else if (_.isElement(active = active.querySelector('[data-value]'))) {
					value = active.dataset.value;
				}
				e.target.value = value;
			}
		}, ADA_DOM_UPDATE_TIMEOUT_MIN);
	}

	else if (_.includes([13, 32], keyCode(e)) && e.target.matches('[role="button"]')) {
		const patterns = {
			13: /input|span|div/i,
			32: /a|li|span|div/i,
		};
		if (patterns[keyCode(e)].test(e.target.tagName)) {
			e.preventDefault();
			e.target.click();
		}
	}
}

function ADAclick(e) {
	if (_.isElement(e.target.closest('button[readonly], a[readonly]'))) {
		e.stopImmediatePropagation();
		e.preventDefault();
	}

	else if (_.isElement(e.target.closest('[role="tab"]'))) {
		if (_.isElement(e.target.closest('[aria-expanded="true"]'))) {
			const action = e.target.closest(`
				button:not([tabindex="-1"]),
				[role="button"][tabindex]:not([tabindex="-1"]),
				a[href]:not([tabindex="-1"])
			`);
			if (_.isNull(action)) {
				e.stopPropagation();
			}
		}
	}

	else {
		_.each([e.target, e.target.previousElementSibling, e.target.parentNode], node => {
			if (_.isElement(node) && node.matches('[role="button"][aria-controls]')) {
				let control = node.getAttribute('aria-controls');
				if (control) {
					window.setTimeout(() => {
						node = $content.querySelector('#' + control);
						if (_.isElement(node) && _.isElement(node = queryFocusable(node))) {
							node.focus();
						}
					}, ADA_DOM_UPDATE_TIMEOUT);
					return false;
				}
			}
		});
	}
}

let $content;
window.onload = () => {
	$content = document.querySelector(ADA_DOM_TARGET) || document.body;
	$content.addEventListener('click', ADAclick, true);
	$content.addEventListener('keydown', ADAkeydown, true);
	addEventListenerOnce($content, 'keydown', () => document.body.classList.add('apply-outline'), {
		condition: e => keyCode(e) === 9
	});
};

export default { install (Vue, options) {
	Vue.mixin({
		data() {
			return {
				ADA_DOM_UPDATE_TIMEOUT: ADA_DOM_UPDATE_TIMEOUT,
				ada_initial_focus: null,
				ada_isolate_selector: null,
			};
		},

		computed: {
			_() {
				return _;
			},
		},

		mounted() {
			if (_.isElement(this.$el) && this.$el.matches('.v-input')) {
				const input = this.$el.querySelector(`
					input[type="text"]:not([aria-describedby]),
					input[type="email"]:not([aria-describedby]),
					input[type="password"]:not([aria-describedby])
				`);
				if (_.isElement(input)) {
					const message = this.$el.querySelector('.v-messages');
					if (_.isElement(message)) {
						message.id = Math.random().toString(36).substr(2, 9);
						input.setAttribute('aria-describedby', message.id);
					}
				}
			}
		},

		methods: {
			ADAattr: function (type, ...args) {
				switch (type) {
					case 'h1':
						return {
							'role': 'heading',
							'aria-live': 'assertive',
							'tabindex': 0,
						};
					case 'h2':
						return {
							'role': 'heading',
							'aria-live': 'polite',
							'tabindex': 0,
						};
					case 'label':
						return {
							'aria-label': _.get(args, 0, null),
						};
					case 'focus':
						var tabindex = _.get(args, 0, 0);
						if (!_.isNumber(tabindex)) {
							tabindex = tabindex ? 0 : -1;
						}
						return {
							'tabindex': tabindex,
						};
					case 'hidden':
						var hidden = Boolean(_.get(args, 0, true));
						return {
							'aria-hidden': hidden,
							'tabindex': hidden ? -1 : null,
						};
					case 'sr-only':
						var tabindex = _.get(args, 0, 0);
						if (!_.isNumber(tabindex)) {
							tabindex = tabindex ? 0 : -1;
						}
						return {
							'role': 'heading',
							'class': 'sr-only',
							'tabindex': tabindex,
						};
					case 'link':
						return {
							'role': 'link',
							'aria-label': _.get(args, 0, null),
						};
					case 'button':
						return {
							'role': 'button',
							'aria-label': _.get(args, 0, null),
						};
					case 'button-readonly':
						const readonly = _.get(args, 0, false);
						return {
							'class': readonly ? 'v-btn--disabled' : null,
							'readonly': readonly ? 'readonly' : null,
							'aria-label': readonly ? _.get(args, 2, 'Please wait') : _.get(args, 1, null),
							'disabled': null,
						};
					case 'list':
						return {
							'data-active-selector': _.get(args, 0, '.v-list__tile--highlighted'),
						};
					case 'control':
						return {
							'role': 'button',
							'aria-controls': _.get(args, 0, null),
							'aria-label': _.get(args, 1, null),
						};
					case 'tablist':
						return {
							'role': 'tablist',
							'aria-label': _.get(args, 0, null),
						};
					case 'tab':
						var tabindex = _.get(args, 0, 0);
						if (!_.isNumber(tabindex)) {
							tabindex = tabindex ? 0 : -1;
						}
						return {
							'role': 'tab',
							'tabindex': tabindex,
							'aria-selected': (tabindex > -1).toString(),
							'aria-controls': _.get(args, 1, null),
							'aria-label': _.get(args, 2, null),
						};
					case 'tabpanel':
						return {
							'role': 'tabpanel',
						};
					case 'progress':
						return {
							'role': 'progressbar',
							'aria-valuetext': _.get(args, 0, 'Loading'),
							'aria-valuemin': _.get(args, 1, 0),
							'aria-valuemax': _.get(args, 2, 100),
							'aria-valuenow': _.get(args, 3, _.get(args, 1, 0)),
						};
					case 'dialog':
						return {
							'aria-modal': true,
							'aria-hidden': Boolean(_.get(args, 0, true)).toString(),
							'aria-labelledby': _.get(args, 1, null),
						};
					case 'alert':
						var role = 'alert';
						var live = _.get(args, 0, 'assertive');
						if (_.isNumber(live)) {
							live = ['polite', 'assertive', 'assertive'][Math.min(live, 2)];
						}
						if (live === 'polite') {
							role = 'status';
						}
						return {
							'role': role,
							'aria-live': live,
							'aria-atomic': true,
						};
					case 'img':
						return {
							'role': 'img',
							'aria-label': _.get(args, 0, null),
							'alt': _.get(args, 0, null),
						};
					case 'iframe':
						return {
							'title': _.get(args, 0, ''),
						};
					default:
						return {};
				}
			},

			ADAquerySelector(type) {
				switch (type) {
					case 'alert':
						return '[aria-atomic]';
					default:
						return null;
				}
			},

			ADAfocus: function (target, isolate) {
				if (!_.isEmpty(_.pick(this.$data, target))) {
					if (_.isUndefined(_.find(this._watchers, ['expression', target]))) {
						this.$watch(target, set => {
							if (this.ada_isolate_selector = isolate) {
								if (set) {
									window.addEventListener('focusin', this.ADAisolateFocus);
								} else {
									window.removeEventListener('focusin', this.ADAisolateFocus);
								}
							}
							if (set) {
								if (document.activeElement !== document.body) {
									this.ada_initial_focus = document.activeElement;
								}
							} else {
								window.setTimeout(() => {
									if (_.isElement(this.ada_initial_focus)) {
										this.ada_initial_focus.focus();
										this.ada_initial_focus = null;
									}
								}, ADA_DOM_UPDATE_TIMEOUT);
							}
						});
					}
				} else {
					window.setTimeout(() => {
						if (_.isString(target) && $content) {
							target = $content.querySelector(target);
						}
						if (_.isElement(target) && _.isElement(target = queryFocusable(target))) {
							target.focus();
						}
					}, ADA_DOM_UPDATE_TIMEOUT);
				}
			},

			ADAisolateFocus: function (e) {
				const selector = this.ada_isolate_selector;
				let visible = _.head(_.filter($content.querySelectorAll(selector), node => isVisible(node)));
				if (_.isElement(visible) && _.isElement(visible = queryFocusable(visible.parentNode))) {
					if (!e.target.closest(selector) && !e.target.parentNode.querySelector(selector)) {
						visible.focus();
					}
				}
			},

			ADAformatDate: function (date, _default = date) {
				if (!_.isDate(date = new Date(date)) || /^[a-z]+ \d+$/i.test(_.trim(arguments[0]))) {
					if (_.isDate(date = new Date(arguments[0] + ' ' + new Date().getFullYear()))) {
						return `${getOrdinalDate(date)} of ${getFullMonth(date)}`;
					}
					return _default;
				}
				return `${getOrdinalDate(date)} of ${getFullMonth(date)} ${date.getFullYear()}`;
			},

			ADAtoUpperNearest: function (number, n = 10) {
				return Math.ceil(Math.abs(_.toSafeInteger(number)) / n) * n;
			},

			ADAreadEachSymbol: function (str) {
				return _.toString(str).replace(/\s/g, '').split('').join(' ');
			},
		},
	});
}};
